"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIntegrationNameByAppId = exports.createGetIntegrationNameByAppId = exports.integrationsHttpClient = exports.getIntegrationPropertiesById = exports.createGetIntegrationPropertiesById = exports.getIntegrations = exports.createGetIntegrations = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formatReferences = require("reference-resolvers/lib/formatReferences");

var _get = _interopRequireDefault(require("transmute/get"));

var _formatIntegrationProperties = _interopRequireDefault(require("reference-resolvers/formatters/formatIntegrationProperties"));

var _formatIntegrationNames = _interopRequireDefault(require("reference-resolvers/formatters/formatIntegrationNames"));

var _promiseClient = _interopRequireDefault(require("hub-http/adapters/promiseClient"));

var core = _interopRequireWildcard(require("hub-http/middlewares/core"));

var hubapi = _interopRequireWildcard(require("hub-http/middlewares/hubapi"));

var debug = _interopRequireWildcard(require("hub-http/middlewares/debug"));

var externalAuth = _interopRequireWildcard(require("hub-http/middlewares/externalAuth"));

var _hubHttp = require("hub-http");

var BASE_URL = '/integrators/v1';
var EVENT_TYPE_BASE_URL = BASE_URL + "/portal-installs/event-types";
var APP_BASE_URL = BASE_URL + "/applications";

var createGetIntegrations = function createGetIntegrations(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get(EVENT_TYPE_BASE_URL).then((0, _formatReferences.formatToReferencesList)({
      getId: (0, _get.default)('id'),
      getLabel: (0, _get.default)('name')
    }));
  };
};

exports.createGetIntegrations = createGetIntegrations;
var getIntegrations = createGetIntegrations({
  httpClient: _apiClient.default
});
exports.getIntegrations = getIntegrations;

var createGetIntegrationPropertiesById = function createGetIntegrationPropertiesById(_ref2) {
  var httpClient = _ref2.httpClient;
  return function (ids) {
    return httpClient.post(EVENT_TYPE_BASE_URL + "/properties", {
      data: {
        ids: ids
      }
    }).then(function (response) {
      return (0, _formatIntegrationProperties.default)(response);
    });
  };
};

exports.createGetIntegrationPropertiesById = createGetIntegrationPropertiesById;
var getIntegrationPropertiesById = createGetIntegrationPropertiesById({
  httpClient: _apiClient.default
}); // same as hubapiStack but without core.jsonResponse

exports.getIntegrationPropertiesById = getIntegrationPropertiesById;
var integrationsHttpClient = (0, _promiseClient.default)((0, _hubHttp.createStack)(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly, hubapi.hubapi, externalAuth.cookieAuthentication, core.withQuery, debug.rewriteUrl, hubapi.timeoutInQuery, core.reportOptionsError, hubapi.logoutOnUnauthorized, hubapi.retryOnError, core.validateStatus));
exports.integrationsHttpClient = integrationsHttpClient;

var createGetIntegrationNameByAppId = function createGetIntegrationNameByAppId(_ref3) {
  var httpClient = _ref3.httpClient;
  return function (appIds) {
    return Promise.all(appIds.map(function (appId) {
      return httpClient.get(APP_BASE_URL + "/" + appId + "/name").then(function (integrationName) {
        return {
          appId: appId,
          integrationName: integrationName
        };
      }, function (error) {
        return {
          appId: appId,
          error: error
        };
      });
    })).then(_formatIntegrationNames.default);
  };
};

exports.createGetIntegrationNameByAppId = createGetIntegrationNameByAppId;
var getIntegrationNameByAppId = createGetIntegrationNameByAppId({
  httpClient: integrationsHttpClient
});
exports.getIntegrationNameByAppId = getIntegrationNameByAppId;